import React from "react";
import { Link } from "@reach/router";

import { Button } from "@material-ui/core";

export const ButtonLink = (props) => (
  <Button component={Link} {...props} />
);
